module.exports = __webpack_public_path__ + "media/images/river/shirt-carousel/shirt-1-6b16cc78eb78c298797d4d3837d13a5c.jpg";